var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.CONTENT_CARD_BY_TYPE[_vm.content.type],_vm._g(_vm._b({tag:"component",attrs:{"content":_vm.content}},'component',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }